// @mui
import { styled } from '@mui/material/styles';
import { Typography, Stack, Avatar } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
import AppCache from '../../../services/appcache';
// ---------------------------------------------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center'
}));
// ---------------------------------------------------------------------------------------------------------

// const userRoles = [
//    { id: 1, name: 'Sales Manager' },
//    { id: 2, name: 'Supervisor' },
//    { id: 3, name: 'Field Staff' }
// ];
// ---------------------------------------------------------------------------------------------------------

export default function NetRetailNavAccount() {

    // const { user } = useAuthContext();
    // const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    // const userName = `${currentLoggedInUser.UserFirstName} ${currentLoggedInUser.UserLastName}` || currentLoggedInUser.UserName;

    return (
        <StyledRoot>
            <Stack direction='column' justifyContent='space-between' flexGrow={1} sx={{ mx: 4, mt: 1, mb: 3 }}>
                {/* <Avatar src={currentLoggedInUser.ProfileImage} alt="photoURL" /> */}

                <Typography variant="caption" sx={{ color: 'common.black' }}>
                    Summaya Nadaf
                </Typography>

                <Typography variant="subtitle2" sx={{ color: 'common.black' }}>
                   CoE-Net Retail
                </Typography>

            </Stack>

        </StyledRoot>
    );
}
